import * as React from 'react';

/**
 * `beforeinstallprompt` is absent from the DOM lib: no `WindowEventMap` entry, no declared event
 * type, so `event.prompt()` fails `TS2339` against a plain `Event`. Declared locally rather than via
 * a global augmentation.
 */
export type BeforeInstallPromptEvent = Event & {
	prompt(): Promise<void>;
	readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

export type InstallPromptContextValue = {
	readonly deferredEvent: BeforeInstallPromptEvent | null;
	readonly clearDeferredEvent: () => void;
};

const InstallPromptContext = React.createContext<InstallPromptContextValue | null>(null);

export default InstallPromptContext;
